<template lang="pug">
v-app
  WarningSelect(v-show='!lojaSelecionada')
  v-container(grid-list-xl, fluid, v-show="lojaSelecionada")
    v-layout(row, wrap)
      v-flex(lg12)
        .headline Perguntas Frequentes
    v-layout(row, wrap)
      v-flex(lg12)
        v-expansion-panel
          v-expansion-panel-content(v-for='(item,i) in perguntas' :key='i')
            template(v-slot:header='')
              div.subheading.font-weight-medium {{ i + 1 }} - {{ item.pergunta }}
            v-card.ml-3.mr-3.mb-3
              v-card-text
                | {{ item.resposta }}

</template>

<script>

import _ from 'lodash';
import WarningSelect from '@/components/WarningSelect';

export default {
  data () {
    return {
      perguntas: [
        { pergunta: 'Como Funcionam os Cupons de Desconto?', resposta: 'A função dos cupons de desconto é aumentar a divulgação e o número de pedidos para nossos parceiros. Com relação ao valor descontado nos pedidos, o Bigou ressarce todo esse montante na comissão do mês seguinte, assim não existe nenhum prejuízo em aceitar cupons, sendo até um facilitador para a divulgação de seu estabelecimento.'},
        // { pergunta: 'Posso não aceitar Cupons de Desconto?', resposta: 'Sim, cada parceiro pode escolher se aceitará cupons ou não. Caso não queira aceitar cupons, basta acionar o suporte ao parceiro, que eles tratarão de desabilitar esta opção, entretanto os cupons de desconto servem para aumentar a divulgação e o número de pedidos do seu estabelecimento.'},
        { pergunta: 'Quem paga os Cupons de Desconto?', resposta: 'Todos os cupons utilizados na sua loja são ressarcidos pelo Bigou na comissão do mês seguinte, sendo assim nenhum estabelecimento é prejudicado por aceitar cupons, visto que o desconto que o usuário recebe, a plataforma paga ao parceiro.'},
        { pergunta: 'Onde eu vejo os Cupons que aceitei na minha loja?', resposta: 'Você consegue conferir o valor total dos cupons que seu estabelecimento aceitou conferindo a página de extrato do seu estabelecimento, ali está o valor dos cupons de desconto aceitos, além disso você pode filtrar o período desejado.'},
        { pergunta: 'A Comissão é cobrada sobre a Taxa de Entrega?', resposta: 'Sim, a comissão do aplicativo é cobrada sobre o valor total do pedido, considerando também a taxa de entrega.'},
        { pergunta: 'Não encontrei um bairro em que entrego, o que faço?', resposta: 'Caso você não encontre algum bairro em que faça entregas, confira se este já não está cadastrado com outro nome, caso não esteja, basta entrar em contato com nosso Suporte ao Parceiro e pedir o cadastro do bairro, que após análise liberaremos o bairro para entregas.'},
        { pergunta: 'Tenho que definir um valor de cobrança por bairro?', resposta: 'Sim, é preciso definir um valor de cobrança para cada bairro onde seu estabelecimento entrega, mesmo que seja taxa grátis. Você tem autonomia para fazer edições nas taxas cobradas por bairro, para isso basta acessar o Gestor de Pedidos do Bigou.'},
        { pergunta: 'Preparei o produto e meu cliente cancelou o pedido, posso ser ressarcido?', resposta: 'Quando um pedido é cancelado, o Bigou automaticamente deixa de cobrar a comissão do mesmo, entretanto não temos outra medida de auxiliar o parceiro em casos como este, visto que o Bigou é apenas um intermediador do pedido, como o telefone ou WhatsApp.'},
        // { pergunta: 'Recusei um pedido e o usuário fez uma avaliação, posso excluir a avaliação?', resposta: 'As avaliações dos usuários englobam todo processo do pedido, desde o momento em que escolhe o que pedirá, até as características do produto que o mesmo recebe em sua casa. Com isso, fica impossível excluir as avaliações deixadas pelos usuários quando efetuam um pedido. O que recomendamos é que o estabelecimento entre em contato com o usuário para buscar entender melhor os motivos da avaliação.'},
        { pergunta: 'O usuário recebeu seu pedido mas avaliou de uma forma que não concordo, o que pode ser feito?', resposta: 'Quando ocorre uma avaliação que vai de encontro ao ponto de vista do parceiro, recomendamos que entre em contato com o usuário, para tentar entender melhor os motivos da avaliação. Neste caso ficamos impossibilitados de excluir a avaliação, visto que os usuários têm o direito de expressar sua opinião sobre a experiência tida na plataforma.'}
      ],
      lojaSelecionada: false
    }
  },
  components: {
    WarningSelect
  },
  computed: {
    list () {
      return this.pagamentos;
    },
    estabelecimentoSelecionado() {
      return this.$root.estabelecimentoSelecionado;
    }
  },
  created () {
    this.validarEstabelecimento();
  },
  watch: {
    estabelecimentoSelecionado() {
      this.validarEstabelecimento();
    }
  },
  methods: {
    validarEstabelecimento() {
      this.lojaSelecionada = !!this.estabelecimentoSelecionado

      if(this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.cardapio_digital) {
        this.$router.push({ path: '/delivery' });
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
